"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var buffer_1 = require("buffer");
var paste_1 = require("../pastes/paste");
var codefile_1 = require("../pastes/codefile");
var pastefile_1 = require("../pastes/pastefile");
var PasteParserV3 = /** @class */ (function () {
    function PasteParserV3() {
    }
    PasteParserV3.prototype.parse = function (name, key, pasteData) {
        var paste = new paste_1.default(name, key);
        paste.files = pasteData.files.map(function (f, i) {
            if (codefile_1.default.isReadable(f.meta.mime)) {
                return new codefile_1.default(i, f.name, buffer_1.Buffer.from(f.data.buffer).toString('utf8'), f.meta.highlight);
            }
            return new pastefile_1.default(i, f.name, buffer_1.Buffer.from(f.data.buffer).toString('base64'), f.meta.mime);
        });
        return paste;
    };
    return PasteParserV3;
}());
exports.default = PasteParserV3;
